"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var CheckmarkIcon = function CheckmarkIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M12 20c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2"
  }), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M14.3 9.043l-3.638 3.637-.823-1.235a1 1 0 1 0-1.664 1.11l1.5 2.25a1 1 0 0 0 1.539.152l4.5-4.5A1 1 0 0 0 14.3 9.043"
  })));
};

CheckmarkIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Success",
  color: "#096600"
};
var _default = CheckmarkIcon;
exports["default"] = _default;